import { DEFAULT_ACCEPT } from 'lib/constants';
import { ENoticeFile, ESnapshot, EOrganization, exists } from 'lib/types';

export const getOriginalFirebaseStoragePath = (noticeFile: ENoticeFile) => {
  const storagePath = noticeFile.originalFirebaseStoragePath;

  // TODO: Confirm if this check covers all scenarios
  if (storagePath && storagePath.includes('_smashed')) {
    return storagePath.split('_smashed')[0];
  }

  return storagePath;
};

export const getOriginalFileName = (noticeFile: ENoticeFile) => {
  return noticeFile.originalFileName || null;
};

const LINER_ACCEPT =
  '.pdf,.docx,.doc,.txt,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,text/plain';

const DISPLAY_ACCEPT =
  '.rtf,.jpg,.jpeg,.png,.pdf,.csv,.xls,.xlsx,application/rtf,text/rtf,image/jpeg,image/png,application/pdf,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export function getAcceptedFiles(
  newspaper: ESnapshot<EOrganization> | undefined
) {
  // default behavior
  if (!exists(newspaper)) return DEFAULT_ACCEPT;

  const { customAccept } = newspaper.data();
  // go to custom values if set
  if (customAccept) return customAccept;

  // restrict behavior for only display ads
  if (newspaper?.data()?.displayOnlyAds) return DISPLAY_ACCEPT;

  // restrict behavior for disable display
  if (newspaper.data().disableDisplay || newspaper.data().allowedNotices)
    return LINER_ACCEPT;

  // fall through to default
  return DEFAULT_ACCEPT;
}
